import debounce from 'lodash/debounce';
import { useCallback, useState } from 'react';

export default function useWithDebouncedState(initialValue, timeout = 500) {
  const [value, setValue] = useState(initialValue);
  const [debouncedValue, setDebouncedValue] = useState(initialValue);
  const handleDebouncedValueChange = useCallback(debounce(setDebouncedValue, timeout), [
    debounce,
    setDebouncedValue,
    timeout
  ]);

  const handleChange = useCallback(
    (newValue, options = {}) => {
      setValue(newValue);
      if (options.immediate) {
        setDebouncedValue(newValue);
        return;
      }
      handleDebouncedValueChange(newValue);
    },
    [setValue, setDebouncedValue, handleDebouncedValueChange]
  );

  return [value, handleChange, debouncedValue];
}
